module.exports = __webpack_public_path__ + "static/BhavikVora-07d1270d6f959057d797f2db33668457.jpg";